import { ApplicationConfig, APP_INITIALIZER, provideZonelessChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LucideAngularModule, Settings, Trash2 } from 'lucide-angular';

import { provideLottieOptions } from 'ngx-lottie';
import lottie from 'lottie-web';


import { AuthService } from './core/auth/auth.service';

function initAuth(auth: AuthService) {
  return () => {
    const result = auth.tryRestoreSession();
    if (typeof result !== 'undefined' && typeof (result as Promise<any>).catch === 'function') {
      return (result as Promise<any>).catch(() => void 0);
    }
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),

    importProvidersFrom(
      LucideAngularModule.pick({ Settings, Trash2 })
    ),

    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),

    provideLottieOptions({ player: () => lottie }),

    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: initAuth,
      deps: [AuthService],
    },
  ],
};
